import { useEffect, useState } from "react";

import { useForm } from "../../useForm";

import Input from "../../../controls/Input";
import TextArea from "../../../controls/TextArea";

import {
  classNames,
  convertToCurrencyFormat,
  convertToDefEventPara,
  standardWeightOptions,
  stockUnitOfMeasureOptions,
  weightUnitOfMeasureOptions,
  yesOrNoOptions,
  isReadOnlyUser,
} from "../../../../shared/utility";
import SelectMenu from "../../../controls/SelectMenu";
import MediaUi from "../../../importMedia/MediaUi";
import { makeGetApiCall } from "../../../../shared/makeApiCall";
import { buildProductSavePayload } from "../../../../shared/productPayload";

const initialFValues = {
  name: "",
  name_ch: null,
  plu: "",
  upc_code: "",
  description_1: null,
  description_2: null,
  description_3: null,
  disclaimer: null,
  label_graphic: { value: null },
  standard_weight: { value: null },
  upper_set_point: null,
  lower_set_point: null,
  stock_unit_of_measure: { value: -1 },
  allergens: { value: null },
  piece_count: null,
  class: { value: null },
  category: { value: null },
  organic: { value: null },
  box_type: { value: null },
  warehouse_id: { value: null },
  warehouse_location_id: { value: null },
  price_1: null,
  price_2: null,
  price_3: null,
  price_4: null,
  taxable: { value: null },
  taxes: [],
  product_image: null,
  product_image_2: null,
  colour: { value: null },
  odour: { value: null },
  taste: { value: null },
  selling_unit_of_measure: { value: null },
};

export default function ProductDetailsForm(props) {
  const {
    product,
    actionCall,
    isEdit,
    classTypeOptions,
    categoryOptions,
    boxTypeOptions,
    allergenOptions,
    warehouseOptions,
    warehouseLocationsOptions,
    getWarehouseLocations,
    graphicsOptions,
    onDuplicate,
    productColours,
    productOdours,
    productTastes,
    taxRates,
  } = props;

  const [uploadedProductImage, setUploadedProductImage] = useState(null);
  const [uploadedProductImage2, setUploadedProductImage2] = useState(null);
  const [uploadedNutritionFacts, setUploadedNutritionFacts] = useState(null);
  const [
    stockUnitOfMeasureOptionsFiltered,
    setStockUnitOfMeasureOptionsFildered,
  ] = useState(stockUnitOfMeasureOptions);
  const [generatePluLoading, setGeneratePluLoading] = useState(false);
  const [generatePluError, setGeneratePluError] = useState(null);

  const checkSellingUnitOfMeasurementOptions = (stockVal) => {
    var tempArr = [...stockUnitOfMeasureOptions];
    if (stockVal === 1) {
      tempArr.pop();
    } else {
      tempArr.shift();
      tempArr.shift();
    }
    setStockUnitOfMeasureOptionsFildered(tempArr);
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name === "") {
        temp.name = "This field is required.";
      }
    }

    if ("plu" in fieldValues) {
      temp.plu = null;
      if (fieldValues.plu === "") {
        temp.plu = "This field is required.";
      }
    }

    if ("stock_unit_of_measure" in fieldValues) {
      temp.stock_unit_of_measure = null;
      if (fieldValues.stock_unit_of_measure.value < 1) {
        temp.stock_unit_of_measure = "This field is required.";
      }

      if (
        fieldValues.stock_unit_of_measure.value === 2 &&
        fieldValues.selling_unit_of_measure.value !== 3
      ) {
        temp.selling_unit_of_measure = "This field has to be pieces.";
      }
    }

    if ("selling_unit_of_measure" in fieldValues) {
      temp.selling_unit_of_measure = null;
      if (fieldValues.selling_unit_of_measure.value < 1) {
        temp.selling_unit_of_measure = "This field is required.";
      }

      if (fieldValues.stock_unit_of_measure) {
        if (
          fieldValues.stock_unit_of_measure.value === 1 &&
          fieldValues.selling_unit_of_measure.value === 3
        ) {
          temp.selling_unit_of_measure = "This field cannot be pieces.";
        }
      }
    }

    if ("warehouse_id" in fieldValues) {
      temp.warehouse_id = null;
      if (fieldValues.warehouse_id.value < 1) {
        temp.warehouse_id = "This field is required.";
      }
    }

    if ("warehouse_location_id" in fieldValues) {
      temp.warehouse_location_id = null;
      if (fieldValues.warehouse_location_id.value < 1) {
        temp.warehouse_location_id = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    handleMultipleInputChange,
  } = useForm(initialFValues, true, validate);

  const handleGeneratePlu = async () => {
    setGeneratePluError(null);
    setGeneratePluLoading(true);
    const result = await makeGetApiCall("generatePlu");
    setGeneratePluLoading(false);
    if (result.success && result.data?.plu != null) {
      handleInputChange(convertToDefEventPara("plu", result.data.plu));
    } else {
      const msg =
        (typeof result.data === "object" && result.data?.message) ||
        "Could not generate PLU.";
      setGeneratePluError(msg);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall(buildProductSavePayload(values, { isEdit }));
    }
  };

  useEffect(() => {
    if (isEdit) {
      var standardWeightSelected = {};
      if (product) {
        if (product.standard_weight) {
          standardWeightSelected = standardWeightOptions.find(
            (el) => el.value === product.standard_weight,
          );

          if (typeof standardWeightSelected === "undefined") {
            standardWeightSelected = { value: null };
          }
        }
      }

      var stockUnitOfMeasureSelected = { value: -1, label: "" };
      if (product) {
        if (product.stock_unit_of_measure) {
          stockUnitOfMeasureSelected = weightUnitOfMeasureOptions.find(
            (el) => el.value === product.stock_unit_of_measure,
          );

          if (typeof stockUnitOfMeasureSelected === "undefined") {
            stockUnitOfMeasureSelected = { value: -1, label: "" };
          }
        }
      }

      var sellingUnitOfMeasureSelected = {};
      if (product) {
        if (product.selling_unit_of_measure) {
          sellingUnitOfMeasureSelected = stockUnitOfMeasureOptions.find(
            (el) => el.value === product.selling_unit_of_measure,
          );

          if (typeof sellingUnitOfMeasureSelected === "undefined") {
            sellingUnitOfMeasureSelected = { value: null };
          }
        }
      }

      var classTypeSelected = {};
      if (product) {
        if (product.class) {
          classTypeSelected = classTypeOptions.find(
            (el) => el.value === product.class.id,
          );

          if (typeof classTypeSelected === "undefined") {
            classTypeSelected = { value: null };
          }
        }
      }

      var categorySelected = {};
      if (product) {
        if (product.category) {
          categorySelected = categoryOptions.find(
            (el) => el.value === product.category,
          );

          if (typeof categorySelected === "undefined") {
            categorySelected = { value: null };
          }
        }
      }

      var boxTypeSelected = {};
      if (product) {
        if (product.box_type) {
          boxTypeSelected = boxTypeOptions.find(
            (el) => el.value === product.box_type,
          );

          if (typeof boxTypeSelected === "undefined") {
            boxTypeSelected = { value: null };
          }
        }
      }

      var organicSelected = {};
      if (product) {
        if (product.organic) {
          organicSelected = yesOrNoOptions.find(
            (el) => el.value === product.organic,
          );

          if (typeof organicSelected === "undefined") {
            organicSelected = { value: null };
          }
        }
      }

      var allergensSelected = [];
      if (product) {
        if (product.allergens) {
          allergensSelected = allergenOptions.filter((el) =>
            product.allergens.includes(el.value),
          );

          if (typeof allergensSelected === "undefined") {
            allergensSelected = { value: null };
          }
        }
      }

      var taxableSelected = {};
      if (product) {
        if (product.taxable) {
          taxableSelected = yesOrNoOptions.find(
            (el) => el.value === product.taxable,
          );

          if (typeof taxableSelected === "undefined") {
            taxableSelected = { value: null };
          }
        }
      }

      var warehouseSelected = {};
      if (product) {
        if (product.warehouse_id) {
          warehouseSelected = warehouseOptions.find(
            (el) => el.value === product.warehouse_id,
          );

          if (typeof warehouseSelected === "undefined") {
            warehouseSelected = { value: null };
          }
        }
      }

      var warehouseLocationSelected = {};
      if (product) {
        if (product.warehouse_location_id) {
          warehouseLocationSelected = warehouseLocationsOptions.find(
            (el) => el.value === product.warehouse_location_id,
          );

          if (typeof warehouseLocationSelected === "undefined") {
            warehouseLocationSelected = { value: null };
          }
        }
      }

      var labelGraphicSelected = { value: null };
      if (product) {
        if (product.label_graphic) {
          labelGraphicSelected = graphicsOptions.find(
            (el) => el.value === product.label_graphic,
          );

          if (typeof labelGraphicSelected === "undefined") {
            labelGraphicSelected = { value: null };
          }
        }
      }

      var colourSelected = { value: null };
      if (product) {
        if (product.colour) {
          colourSelected = productColours.find(
            (el) => el.value === product.colour,
          );

          if (typeof colourSelected === "undefined") {
            colourSelected = { value: null };
          }
        }
      }

      var odourSelected = { value: null };
      if (product) {
        if (product.odour) {
          odourSelected = productOdours.find(
            (el) => el.value === product.odour,
          );

          if (typeof odourSelected === "undefined") {
            odourSelected = { value: null };
          }
        }
      }

      var tasteSelected = { value: null };
      if (product) {
        if (product.taste) {
          tasteSelected = productTastes.find(
            (el) => el.value === product.taste,
          );

          if (typeof tasteSelected === "undefined") {
            tasteSelected = { value: null };
          }
        }
      }

      // API sends is_new as 1|2; SelectMenu needs a react-select option object
      var isNewSelected = null;
      if (product && product.is_new != null) {
        isNewSelected = yesOrNoOptions.find(
          (el) => el.value === product.is_new,
        );
        if (typeof isNewSelected === "undefined") {
          isNewSelected = null;
        }
      }

      var taxesSelected = [];
      if (product?.taxRates?.length) {
        taxesSelected = taxRates.filter((el) =>
          product.taxRates.includes(el.value),
        );
      }

      setValues({
        ...product,
        standard_weight: standardWeightSelected,
        stock_unit_of_measure: stockUnitOfMeasureSelected,
        selling_unit_of_measure: sellingUnitOfMeasureSelected,
        class: classTypeSelected,
        category: categorySelected,
        box_type: boxTypeSelected,
        organic: organicSelected,
        allergens: allergensSelected,
        taxable: taxableSelected,
        taxes: taxesSelected,
        warehouse_id: warehouseSelected,
        warehouse_location_id: warehouseLocationSelected,
        label_graphic: labelGraphicSelected,
        colour: colourSelected,
        odour: odourSelected,
        taste: tasteSelected,
        is_new: isNewSelected,
      });
      checkSellingUnitOfMeasurementOptions(product.stock_unit_of_measure);
    }
  }, [isEdit, product, setValues, taxRates]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-3 mb-5">
        <div className="px-2 py-4 sm:px-5 card-custom">
          <div className="mt-3 grid grid-cols-7 gap-4">
            <Input
              label="Name *"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              error={errors.name}
              parentClass="col-span-2"
            />
            <Input
              label="Name (CH) *"
              name="name_ch"
              onChange={handleInputChange}
              value={values.name_ch}
              labelOn={true}
              error={errors.name_ch}
              parentClass="col-span-2"
            />
            <div className="flex flex-col gap-1">
              <Input
                label="PLU *"
                name="plu"
                onChange={handleInputChange}
                value={values.plu}
                labelOn={true}
                error={errors.plu}
              />
              <button
                type="button"
                className="self-start text-sm text-purple-600 font-bold disabled:opacity-50"
                disabled={generatePluLoading}
                onClick={handleGeneratePlu}
              >
                {generatePluLoading ? "Generating…" : "Generate"}
              </button>
              {generatePluError ? (
                <p className="self-start text-sm text-red-500">
                  {generatePluError}
                </p>
              ) : null}
            </div>

            <Input
              label="UPC Code"
              name="upc_code"
              onChange={handleInputChange}
              value={values.upc_code}
              labelOn={true}
              error={errors.upc_code}
              parentClass="col-span-1"
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="require_best_before_on_receiving"
              options={yesOrNoOptions.filter((option) => option.value !== -1)}
              value={isEdit ? values.require_best_before_on_receiving : null}
              title={"Best Before Required"}
              error={errors.require_best_before_on_receiving}
              showLabel={true}
            />
          </div>
          <div className="mt-3 grid grid-cols-4 gap-4">
            <TextArea
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              label="Description 1"
              labelOn={true}
              name="description_1"
              onChange={handleInputChange}
              value={values.description_1}
              rows="3"
            />
            <TextArea
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              label="Description 2"
              labelOn={true}
              name="description_2"
              onChange={handleInputChange}
              value={values.description_2}
              rows="3"
            />
            <TextArea
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              label="Description 3"
              labelOn={true}
              name="description_3"
              onChange={handleInputChange}
              value={values.description_3}
              rows="3"
            />
            <TextArea
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              label="Disclaimer"
              labelOn={true}
              name="disclaimer"
              onChange={handleInputChange}
              value={values.disclaimer}
              rows="3"
            />
          </div>
          <div className="mt-3 grid grid-cols-5 gap-4">
            {/* <SelectMenu
              handleInputChange={handleInputChange}
              name="standard_weight"
              options={standardWeightOptions}
              value={values.standard_weight}
              title={"Standard weight"}
              error={errors.standard_weight}
              showLabel={true}
            /> */}
            <SelectMenu
              handleInputChange={(e) => {
                var sellingUofM = values.selling_unit_of_measure;
                if (e.target.value.value === 2) {
                  sellingUofM = stockUnitOfMeasureOptions[2];
                }
                if (e.target.value.value) {
                  checkSellingUnitOfMeasurementOptions(e.target.value.value);
                }

                handleMultipleInputChange({
                  stock_unit_of_measure: e.target.value,
                  selling_unit_of_measure: sellingUofM,
                });
              }}
              name="stock_unit_of_measure"
              options={weightUnitOfMeasureOptions}
              value={values.stock_unit_of_measure}
              title={"Stock unit of measurement *"}
              error={errors.stock_unit_of_measure}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="selling_unit_of_measure"
              options={stockUnitOfMeasureOptionsFiltered}
              value={values.selling_unit_of_measure}
              title={"Selling unit of measurement *"}
              error={errors.selling_unit_of_measure}
              showLabel={true}
            />
            <Input
              label="Piece count"
              name="piece_count"
              onChange={handleInputChange}
              value={values.piece_count}
              labelOn={true}
              type="number"
              parentClass={classNames(
                values.stock_unit_of_measure.value === 2 ? null : "hidden",
              )}
            />
            <Input
              label="Upper set point"
              name="upper_set_point"
              onChange={handleInputChange}
              value={values.upper_set_point}
              labelOn={true}
              type="number"
              step=".01"
            />
            <Input
              label="Lower set point"
              name="lower_set_point"
              onChange={handleInputChange}
              value={values.lower_set_point}
              labelOn={true}
              type="number"
              step=".01"
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="is_new"
              options={yesOrNoOptions.filter((option) => option.value !== -1)}
              value={isEdit ? values.is_new : null}
              title={"Is New"}
              error={errors.is_new}
              showLabel={true}
            />
          </div>
        </div>
        <div className="px-2 py-4 sm:px-5 card-custom">
          <h3 className="font-bold text-lg">Classifications</h3>

          <div className="mt-3 grid grid-cols-6 gap-4">
            <SelectMenu
              handleInputChange={handleInputChange}
              name="class"
              options={classTypeOptions}
              value={values.class}
              title={"Class"}
              error={errors.class}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="category"
              options={categoryOptions}
              value={values.category}
              title={"Category"}
              error={errors.category}
              showLabel={true}
            />
            {/* <SelectMenu
              handleInputChange={handleInputChange}
              name="box_type"
              options={boxTypeOptions}
              value={values.box_type}
              title={"Box type"}
              error={errors.box_type}
              showLabel={true}
            /> */}
            <SelectMenu
              handleInputChange={handleInputChange}
              name="organic"
              options={yesOrNoOptions}
              value={values.organic}
              title={"Organic"}
              error={errors.organic}
              showLabel={true}
            />
            <SelectMenu
              parentClass="col-span-2"
              handleInputChange={handleInputChange}
              name="allergens"
              options={allergenOptions}
              value={values.allergens}
              title={"Allergens"}
              error={errors.allergens}
              showLabel={true}
              isMulti={true}
            />
            <Input
              label="Shelf life"
              name="shelf_life"
              type="number"
              onChange={handleInputChange}
              value={values.shelf_life}
              error={errors.shelf_life}
              labelOn={true}
              step=".01"
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="colour"
              options={productColours}
              value={values.colour}
              title={"Colour"}
              error={errors.colour}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="odour"
              options={productOdours}
              value={values.odour}
              title={"Odour"}
              error={errors.odour}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="taste"
              options={productTastes}
              value={values.taste}
              title={"Taste"}
              error={errors.taste}
              showLabel={true}
            />
          </div>
        </div>

        <div className="px-2 py-4 sm:px-5 card-custom">
          <h3 className="font-bold text-lg">Plant floor behaviour</h3>

          <div className="mt-3 grid grid-cols-7 gap-4">
            <SelectMenu
              handleInputChange={(e) => {
                const selectedId = e.target.value.value;
                getWarehouseLocations(selectedId);
                handleInputChange(
                  convertToDefEventPara("warehouse_id", e.target.value),
                );
              }}
              name="warehouse_id"
              options={warehouseOptions}
              value={values.warehouse_id}
              title={"Warehouse *"}
              error={errors.warehouse_id}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="warehouse_location_id"
              options={warehouseLocationsOptions}
              value={values.warehouse_location_id}
              title={"Location *"}
              error={errors.warehouse_location_id}
              showLabel={true}
            />
            <Input
              label="Re-order limit"
              name="reorder_limit"
              onChange={handleInputChange}
              value={values.reorder_limit}
              labelOn={true}
              type="number"
              step=".01"
            />
            <Input
              label="Current inventory"
              name="current_inventory"
              onChange={handleInputChange}
              value={values.current_inventory}
              labelOn={true}
              disabled={true}
            />
            <Input
              label={
                values.average_unit_cost_basis === "piece"
                  ? "Avg. inv cost / piece"
                  : "Avg. inv cost / kg"
              }
              name="avg_inv_cost"
              onChange={handleInputChange}
              value={
                values.average_unit_cost != null
                  ? convertToCurrencyFormat(values.average_unit_cost)
                  : "—"
              }
              labelOn={true}
              disabled={true}
            />
            <Input
              label="Last unit price"
              name="last_cost_price"
              onChange={handleInputChange}
              value={
                values.unit_cost != null && values.unit_cost !== ""
                  ? convertToCurrencyFormat(values.unit_cost)
                  : "—"
              }
              labelOn={true}
              disabled={true}
            />
            <Input
              label="Storage condition"
              name="storage_condition"
              onChange={handleInputChange}
              value={values.storage_condition}
              labelOn={true}
            />
            <Input
              label="Unit size"
              name="packaging_size"
              onChange={handleInputChange}
              value={values.packaging_size}
              labelOn={true}
            />
            <Input
              label="Packaging material"
              name="packaging_material"
              onChange={handleInputChange}
              value={values.packaging_material}
              labelOn={true}
            />
            <Input
              label="Directions for use"
              name="directions_for_use"
              onChange={handleInputChange}
              value={values.directions_for_use}
              labelOn={true}
            />
            <Input
              label="Country of origin"
              name="country_of_origin"
              onChange={handleInputChange}
              value={values.country_of_origin}
              labelOn={true}
            />
            <Input
              label="Hot key 1"
              name="hot_key_1"
              onChange={handleInputChange}
              value={values.hot_key_1}
              labelOn={true}
            />
            <Input
              label="Hot key 2"
              name="hot_key_2"
              onChange={handleInputChange}
              value={values.hot_key_2}
              labelOn={true}
            />
            <Input
              label="Food safety"
              name="food_safety"
              onChange={handleInputChange}
              value={values.food_safety}
              labelOn={true}
            />
            <Input
              label="Certifications"
              name="certifications"
              onChange={handleInputChange}
              value={values.certifications}
              labelOn={true}
            />
            <TextArea
              parentClass="col-span-2"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              label="Ingredients (EN)"
              labelOn={true}
              name="ingredients_en"
              onChange={handleInputChange}
              value={values.ingredients_en}
              rows="3"
            />
          </div>
        </div>

        <div className="px-2 py-4 sm:px-5 card-custom">
          <h3 className="font-bold text-lg">Costs & Pricing</h3>

          <div className="mt-3 grid grid-cols-7 gap-4">
            <Input
              label="Retail Price"
              name="price_1"
              onChange={handleInputChange}
              value={values.price_1}
              labelOn={true}
              type="number"
              step="0.01"
            />
            <Input
              label="Distributor Price"
              name="price_2"
              onChange={handleInputChange}
              value={values.price_2}
              labelOn={true}
              type="number"
              step="0.01"
            />
            <Input
              label="Wholesale Price"
              name="price_3"
              onChange={handleInputChange}
              value={values.price_3}
              labelOn={true}
              type="number"
              step="0.01"
            />
            <Input
              label="GMG Stores ($0)"
              name="price_4"
              onChange={handleInputChange}
              value={values.price_4}
              labelOn={true}
              type="number"
              step="0.01"
            />
            <Input
              label="Avg. Sales (12 Months)"
              name="avg_sales_12_months"
              onChange={handleInputChange}
              value={values.avg_sales_12_months}
              labelOn={true}
              disabled={true}
            />
            <Input
              label="Last carton cost"
              name="unit_cost"
              onChange={handleInputChange}
              value={values.unit_cost}
              labelOn={true}
              disabled={true}
              type="number"
              step=".01"
            />
          </div>

          <div className="mt-3 grid grid-cols-7 gap-4">
            <SelectMenu
              handleInputChange={(e) => {
                const selected = e.target.value;
                handleInputChange(convertToDefEventPara("taxable", selected));
                if (selected?.value !== 2) {
                  handleInputChange(convertToDefEventPara("taxes", []));
                }
              }}
              name="taxable"
              options={yesOrNoOptions}
              value={values.taxable}
              title={"taxable"}
              error={errors.taxable}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="taxes"
              options={taxRates}
              value={values.taxes}
              title={"Taxes"}
              error={errors.taxes}
              showLabel={true}
              isMulti={true}
              disabled={values.taxable?.value !== 2}
              parentClass="col-span-2"
            />
          </div>
        </div>

        <div className="px-2 py-4 sm:px-5 card-custom grid grid-cols-1 sm:grid-cols-4 gap-4">
          <div>
            <SelectMenu
              handleInputChange={handleInputChange}
              name="label_graphic"
              options={graphicsOptions}
              value={values.label_graphic}
              title={"Label graphic"}
              error={errors.label_graphic}
              showLabel={true}
            />
            {values.label_graphic.value !== null ? (
              <img
                src={values.label_graphic.value}
                alt={values.label_graphic.value}
                title={values.label_graphic.value}
                className="media-image rounded-md"
                height="200"
                width="200"
              />
            ) : null}
          </div>

          <MediaUi
            title="Product image"
            uploadedImage={uploadedProductImage}
            setUploadedImage={setUploadedProductImage}
            isEdit={isEdit}
            imageUrl={values.product_image_url}
            imageName="product_image"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                product_image: "",
                product_image_url: null,
              });
              setUploadedProductImage(null);
            }}
          />

          <MediaUi
            title="Product image 2"
            uploadedImage={uploadedProductImage2}
            setUploadedImage={setUploadedProductImage2}
            isEdit={isEdit}
            imageUrl={values.product_image_2_url}
            imageName="product_image_2"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                product_image_2: "",
                product_image_2_url: null,
              });
              setUploadedProductImage2(null);
            }}
          />

          <MediaUi
            title="Nutrition Facts"
            uploadedImage={uploadedNutritionFacts}
            setUploadedImage={setUploadedNutritionFacts}
            isEdit={isEdit}
            imageUrl={values.nutrition_facts_url}
            imageName="nutrition_facts"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                nutrition_facts: "",
                nutrition_facts_url: null,
              });
              setUploadedNutritionFacts(null);
            }}
          />
        </div>

        <div className="sm:flex-no-wrap">
          {!isReadOnlyUser() && (
            <div className="my-auto flex items-center">
              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center mt-3"
              >
                Save
              </button>
              <button
                type="button"
                className={classNames(
                  isEdit
                    ? "ml-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-700 items-center mt-3"
                    : "hidden",
                )}
                onClick={onDuplicate}
              >
                Duplicate
              </button>
            </div>
          )}
        </div>
      </div>
    </form>
  );
}
